// add google analytics script
const addGoogleScript = ({googleEvent}) => {
    if(googleEvent) {
      const script = document.createElement("script");
      script.async = true;
      script.defer = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${googleEvent}`;

      const script2 = document.createElement("script");

      script2.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', "${googleEvent}");`;

      document.head.appendChild(script);
      document.head.appendChild(script2);
    };
};

// add tiktok pixel script
const addTiktokScript = ({tiktokEvent}) => {
  if(tiktokEvent) {
    const script = document.createElement("script");
    script.defer = true;
    script.async = true;

    script.innerHTML=`!function (w, d, t) {
		  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++
      )ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
		
		  ttq.load('${tiktokEvent}');
		  ttq.page();
		}(window, document, 'ttq');`

    document.head.appendChild(script);
  };
};

// add facebook pixel script
const addFbScript = ({ref,fbEvent}) => {
    if(fbEvent) {
      const script = document.createElement("script");
      const noScript = document.createElement("noscript");
  
      script.async = true;
      script.defer = true;
      
      script.innerHTML=`!function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', ${fbEvent});
      fbq('track', 'PageView');`;
  
      noScript.innerHTML = `<img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=${fbEvent}&ev=PageView&noscript=1"
        />
      `;
  
      ref.current.appendChild(script); 
      ref.current.appendChild(noScript); 
    };
};

// add tapfiliate script
const addTapfiliateScript = ({tapfiliateEvent}) => {
    if(tapfiliateEvent) {
      let script = document.createElement("script");
      script.async = true;
      script.defer = true;
      script.type = 'text/javascript';
      script.src = `https://script.tapfiliate.com/tapfiliate.js`;

      let script2 = document.createElement("script");
      script2.type = "text/javascript";
      script2.defer = true;
      script2.async = true;

      script2.innerHTML = `(function(t,a,p){t.TapfiliateObject=a;t[a]=t[a]||function(){ (t[a].q=t[a].q||[]).push(arguments)}})(window,'tap');

      tap('create', '${tapfiliateEvent}', { integration: "javascript" });
      tap('detect');`;


      document.head.appendChild(script);
      document.head.appendChild(script2);
    };
};

export {
    addGoogleScript,
    addFbScript,
    addTapfiliateScript,
    addTiktokScript
};